// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>21</span>&nbsp;&nbsp;Save me from the lion&#146;s mouth,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;from the horns of wild oxen.&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;You have answered me!<br> </p> </div></div>";
// Exports
module.exports = code;